var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"loading"},[_vm._v("Loading...")])])])])}]

export { render, staticRenderFns }